import { useFeatureFlags } from 'Utilities/hooks';

export const useAuthUI = () => {
  const { useAuthUI: isAuthUIJourney } = useFeatureFlags();

  return {
    isAuthUIJourney,
  };
};
